export default "__VITE_ASSET__BiNMnbg7__"